"use client";

import { useEffect } from "react";
import { trackArticleOpen } from "@/lib/analytics";

const recentArticleOpenKeys = new Set<string>();

type ArticleViewBeaconProps = {
  articleId: string;
  articleSlug: string;
  articleTitle: string;
  categorySlug?: string | null;
  categoryName?: string | null;
  authorUsername?: string | null;
  isBreaking: boolean;
  isFeatured: boolean;
};

export function ArticleViewBeacon({
  articleId,
  articleSlug,
  articleTitle,
  categorySlug,
  categoryName,
  authorUsername,
  isBreaking,
  isFeatured,
}: ArticleViewBeaconProps) {
  useEffect(() => {
    const articleOpenKey = `${articleId}:${articleSlug}`;
    if (!recentArticleOpenKeys.has(articleOpenKey)) {
      recentArticleOpenKeys.add(articleOpenKey);
      window.setTimeout(() => recentArticleOpenKeys.delete(articleOpenKey), 2000);
      trackArticleOpen({
        articleId,
        articleSlug,
        articleTitle,
        categorySlug,
        categoryName,
        authorUsername,
        isBreaking,
        isFeatured,
      });
    }

    const body = JSON.stringify({ articleId });

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon("/api/article-view", blob);
      return;
    }

    fetch("/api/article-view", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  }, [articleId, articleSlug, articleTitle, authorUsername, categoryName, categorySlug, isBreaking, isFeatured]);

  return null;
}
